import React from 'react'

const ReportBuilder = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.83337 14.1666V10.8333" stroke={props.color ? props.color : "#202327"} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 14.1666V5.83325" stroke={props.color ? props.color : "#202327"} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14.1666 14.1667V9.16675" stroke={props.color ? props.color : "#202327"} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M2.08337 9.99992C2.08337 6.26797 2.08337 4.40199 3.24274 3.24262C4.40212 2.08325 6.26809 2.08325 10 2.08325C13.732 2.08325 15.598 2.08325 16.7574 3.24262C17.9167 4.40199 17.9167 6.26797 17.9167 9.99992C17.9167 13.7318 17.9167 15.5978 16.7574 16.7573C15.598 17.9166 13.732 17.9166 10 17.9166C6.26809 17.9166 4.40212 17.9166 3.24274 16.7573C2.08337 15.5978 2.08337 13.7318 2.08337 9.99992Z" stroke={props.color ? props.color : "#202327"} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
    
  )
}

export default ReportBuilder
